import React from 'react';
import closeIcon from '../../../../../../assets/icons/icon-close-red.svg';
import InteractiveButton from '../../Buttons/Interactive';
import LightBox from '../../../../../components/LightBox';
import Icon from '../../../../../components/Icon';
import Block from '../../../../../components/Block';

const Modal = (props: any) => {
  const { isLightBoxOpen, contentLightBox, onClick } = props;
  return (
    <LightBox IsModalOpen={isLightBoxOpen} autoCloseLayer>
      <Block
        width="100%"
        customized
        flexDirection="row"
        justifyContent="flex-end"
        padding="8px 4px 0px"
      >
        <InteractiveButton
          bkgColorEnabled="none"
          bkgColorHover="#FED4D6"
          bkgColorFocus="#FDADB3"
          bkgColorPressed="#FDADB3"
          borderRadius="4px"
          customized
          // onClick={() => {
          //   handleLightBox(false, null);
          // }}
          onClick={onClick}
        >
          <Icon
            customized
            minWidth="40px"
            height="40px"
            alignItems="center"
            justifyContent="center"
          >
            {/* <Icon name="x" size={28} /> */}
            <img src={closeIcon} alt="other" />
          </Icon>
        </InteractiveButton>
      </Block>
      {contentLightBox}
    </LightBox>
  );
};

export default Modal;
